import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-sd-card",
  "use": "icon-si-glyph-sd-card-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-sd-card\" id=\"icon-si-glyph-sd-card\"><title>886</title><defs class=\"si-glyph-fill\"></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(2.000000, 1.000000)\" fill=\"#434343\"><rect x=\"3\" y=\"8\" width=\"5.906\" height=\"4.938\" class=\"si-glyph-fill\" /><path d=\"M10.969,4.938 L11.938,4.938 L11.938,0.063 L3,0.063 L0.022,5.215 L0.022,6.969 L1.031,6.969 L1.031,8.022 L0.022,8.022 L0.022,15.938 L11.937,15.938 L11.937,8.022 L10.968,8.022 L10.968,4.938 L10.969,4.938 Z M8,0.969 L9,0.969 L9,3 L8,3 L8,0.969 L8,0.969 Z M6,0.969 L7,0.969 L7,3 L6,3 L6,0.969 L6,0.969 Z M4,1 L5.031,1 L5.031,3.031 L4,3.031 L4,1 L4,1 Z M10,14.025 L1.993,14.025 L1.993,6.937 L10,6.937 L10,14.025 L10,14.025 Z M11,3 L10,3 L10,0.969 L11,0.969 L11,3 L11,3 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-sd-card.svg
// module id = VJss
// module chunks = 62